import * as React from "react";
const SvgFiRrBoxCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-box-check_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v1c0 .886.387 1.684 1 2.234V19c0 2.757 2.243 5 5 5h12c2.757 0 5-2.243 5-5V8.234c.613-.55 1-1.347 1-2.234V5c0-2.757-2.243-5-5-5M2 5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v1a1 1 0 0 1-1 1H3c-.551 0-1-.448-1-1zm19 14c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V9h18zM6.295 15.71a1 1 0 1 1 1.41-1.42l2.432 2.414a1.02 1.02 0 0 0 1.416.003l4.766-4.438a1 1 0 0 1 1.363 1.463l-4.74 4.414a2.96 2.96 0 0 1-2.096.854 2.98 2.98 0 0 1-2.122-.879z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-box-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoxCheck;
